<!-- <div>tille : {{previw_data.title}}</div> -->

<div class="blog_modal_main_width">
    <div class="blog_mdl_heading_sec">
        <h1>Preview</h1>
    </div>
    <div class="blog_mdl_data_sec_main">
        <!-- <div class="blog_data_sec">
            <h5><strong>_id:</strong></h5> 
            <p>[[66e174cf15ea626b886f46f7]]</p>
        </div> -->
        <div class="blog_data_sec cng_bg">
            <h5><strong>Title:</strong></h5>
            <p>{{previw_data.title}}</p>
        </div>
        <div class="blog_data_sec">
            <h5><strong>Description:</strong></h5> 
            <p>[[At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.]]</p>
        </div>
        <div class="blog_data_sec cng_bg">
            <h5><strong>Video:</strong></h5>
            <p>[[]]</p>
        </div>
        <div class="blog_data_sec">
            <h5><strong>Status:</strong></h5>
            <p>[[1]]</p>
        </div>
        <div class="blog_data_sec cng_bg">
            <h5><strong>Prority:</strong></h5>
            <p>[[5]]</p>
        </div>
        <div class="blog_data_sec">
            <h5><strong>Created on:</strong></h5> 
            <p>[[1726051535820]]</p>
        </div>
        <div class="blog_data_sec cng_bg">
            <h5><strong>Updated on:</strong></h5> 
            <p>[[1726052563911]]</p>
        </div>
    </div>
</div>